import classNames from 'classnames';

import styles from './CreateApiUserModal.module.scss';

interface ListItemProps {
    selected: boolean;
    name: string;
    disabled: boolean;
    locationName?: string;
    onToggle: () => void;
}

/**
 * One location or pen an API user can be limited to: a toggle button, so it is in the tab
 * order, Enter and Space press it, and a screen reader announces whether it is chosen.
 */
export function ListItemComponent(props: ListItemProps) {
    const { selected, name, onToggle, disabled, locationName } = props;

    return (
        <button
            type="button"
            className={classNames(styles.listItem, {
                [styles.selectedList]: selected,
                [styles.listItemDisabled]: disabled,
            })}
            aria-pressed={selected}
            disabled={disabled}
            onClick={onToggle}>
            {locationName ? `${locationName} - ${name}` : name}
        </button>
    );
}
